export const getToken = ({ sessionState }) => sessionState.token;

export const getProducts = ({ subscriptionState }) => subscriptionState.products;

export const getSubscription = ({ subscriptionState }) => subscriptionState.subscription;

export const getCurrentCardBrand = ({ brandState }) => brandState.currentBrand;

export const getBrands = ({ brandState }) => brandState.brands;

export const getPixSessionToken = ({ pixState }) => pixState.sessionToken;

/* ------------- UI -------------- */
export const isModalVisible = ({ uiState }) =>
  !uiState.loading.isVisible && uiState.modal.isVisible;

export const isLoadingVisible = ({ uiState }) => uiState.loading.isVisible;

export const getCurrentTarget = ({ uiState }) => uiState.modal.currentTarget;

export const getFlashMessage = ({ uiState }) => uiState.flashMessage;
